import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import { updateSelectedItems } from '../../redux/actions/products';
import { assignmentsByItem } from '../../redux/actions/assignments';

import LoadingSpinner from '../partials/LoadingSpinner';
import { Text, Button, Checkbox, H4, Input, Badge } from '@bigcommerce/big-design';
import { DeleteIcon, EditIcon } from '@bigcommerce/big-design-icons';

import EditAssignmentModal from './EditAssignmentModal';
import DeleteAssignmentModal from './DeleteAssignmentModal';

const ItemLine = ({ 
  payload,
  hasVariants,
  supplierId,
  productId,
  itemId,
  imageUrl,
  fullImageUrl,
  inventoryTracking,
  options,
  name,
  binPickingNumber,
  selectedProductList,
  setSelectedProductList,
  products,
  type,
  rowId,
  quantity,
  price,
  supplierPrice,
  setSupplierPrice,
  minOrder,
  setSupplierMinOrder,
  setSupplierSku,
  setOrderMultiple,
  setPackQuantity,
  supplierSku,
  orderMultiple,
  packQuantity,
  assignments,
  getAssignments,
  bigcommerceSettings,
  submitted,
  settings
}) => {
  const [activeAssignment, setActiveAssignment] = useState(null);
  const [showEditAssignmentModal, setShowEditAssignmentModal] = useState(false);
  const [showDeleteAssignmentModal, setShowDeleteAssignmentModal] = useState(false);

  const [lineAssigned, setLineAssigned] = useState(false);


  let section = !!options ? selectedProductList.variants : selectedProductList.products;
  let inList = Object.keys(section).indexOf(String(itemId)) > -1;

  useEffect(() => {
    if(type === 'variant') {
      getAssignments(payload, supplierId, productId, itemId);
    } else {
      getAssignments(payload, supplierId, productId, null);
    }
  }, []);

  useEffect(() => {
    if((type === 'variant') && assignments.itemAssignments[`${productId}/${itemId}`]) {
      setLineAssigned(assignments.itemAssignments[`${productId}/${itemId}`].find(assignment => assignment?.key === `Supplier-${supplierId}`));
    }

    if((type === 'product') && assignments.itemAssignments[`${productId}/null`]) {
      setLineAssigned(assignments.itemAssignments[`${productId}/null`].find(assignment => assignment?.key === `Supplier-${supplierId}`));
    }
  }, [assignments]);

  const showEditModal = () => {
    let assignment = JSON.parse(lineAssigned.value);
    assignment.product_id = productId;
    if(type === 'variant') { assignment.variant_id = itemId; }

    setActiveAssignment(assignment);
    setShowEditAssignmentModal(true);
  }

  const showDeleteModal = () => {
    let assignment = JSON.parse(lineAssigned.value);
    assignment.product_id = productId;
    assignment.variant_id = itemId;

    setActiveAssignment(assignment);
    setShowDeleteAssignmentModal(true);
  }

  const switchSelection = () => {
    if (inList) {
      delete section[itemId];
    } else {
      section[itemId] = {
        productId: productId,
        imageUrl: imageUrl,
        fullImageUrl: fullImageUrl,
        options: options,
        name: name,
        quantity: quantity,
        price: price,
        binPickingNumber: binPickingNumber
      };
    }

    setSelectedProductList({ ...selectedProductList });
  };

  const setAssignmentValue = (itemId, type, e, setter) => {
    section[itemId] = {
      productId: productId,
      imageUrl: imageUrl,
      fullImageUrl: fullImageUrl,
      options: options,
      name: name,
      quantity: quantity,
      price: price,
      binPickingNumber: binPickingNumber
    };

    setSelectedProductList({ ...selectedProductList });
    setter(itemId, type, e);
  }

  const format = (value) => {
    let formattedValue = "";

    if(bigcommerceSettings.currency_symbol_location === 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }
    
    formattedValue += parseFloat(value).toFixed(bigcommerceSettings.decimal_places)

    if(bigcommerceSettings.currency_symbol_location !== 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }

    formattedValue = formattedValue.replace('.', bigcommerceSettings.decimal_separator)

    return formattedValue;
  }

  return(
    <>
      <div className="has-hover sku-line flex-container">
        <div className={`flex-1 ${type === 'variant' && 'left-15'}`}>
          <div className="flex-container">
            { !lineAssigned && !assignments.itemSearchingAssignments.find(item => item === `${productId}/${itemId}`) && ((inventoryTracking === 'product' && type === 'product') || (inventoryTracking === 'none' && !hasVariants) || (type === 'variant')) &&
              <Checkbox
                id={itemId}
                checked={inList}
                onChange={() => switchSelection()}
              />
            }
            { assignments.itemSearchingAssignments.find(item => item === `${productId}/${itemId}`) &&
              <LoadingSpinner
                size="xxSmall"
                statusText=" "
              />
            }
            <div className="left-15">
              { imageUrl && <img src={imageUrl} /> }
              { !imageUrl && <Text>No image</Text>}
            </div>
          </div>
        </div>
        <div className={lineAssigned ? "flex-1" : "flex-3"}>
          <div className="flex-container">
            <H4>{name}</H4>
          </div>
          <ul>
            { options && options.map(option =>
                <li>
                  <strong>{ option.option_display_name }</strong>: { option.label }
                </li>
              )
            }
            <li>Default Location Stock: { quantity }</li>
            { !options &&
              <Text color="warning40">
                Base Product
              </Text>
            }
            { (inventoryTracking === 'none') &&
              <Text color="danger40">Inventory not tracked</Text>
            }
          </ul>

        </div>

        { !lineAssigned && !assignments.itemSearchingAssignments.find(item => item === `${productId}/${itemId}`) && ((inventoryTracking === 'product' && type === 'product') || (inventoryTracking === 'none' && !hasVariants) || (type === 'variant')) &&
          <div className="flex-3">
            <div className="flex-container flex-end">
              <Text as='span'>Supplier SKU &nbsp;&nbsp;</Text>
              <Input
                required
                onChange={(e) => setAssignmentValue(itemId, type, e, setSupplierSku)}
                placeholder="Supplier SKU"
                value={supplierSku}
                type="text"
                disabled={submitted}
              />
            </div>
            <div className="flex-container flex-end">
              <Text as='span'>Supplier Price &nbsp;&nbsp;</Text>
              <Input
                required
                onChange={(e) => setAssignmentValue(itemId, type, e, setSupplierPrice)}
                placeholder="Supplier Price"
                value={supplierPrice}
                type="number"
                min="0"
                disabled={submitted}
              />
            </div>
            <div className="flex-container flex-end">
              <Text as='span'>Minimum Order Quantity &nbsp;&nbsp;</Text>
              <Input
                required
                onChange={(e) => setAssignmentValue(itemId, type, e, setSupplierMinOrder)}
                placeholder="MOQ"
                value={minOrder}
                type="number"
                min="0"
                step="1"
                disabled={submitted}
              />
            </div>
            { settings?.settings?.order_multiples && 
              <div className="flex-container flex-end">
                <Text as='span'>Order Multiple &nbsp;&nbsp;</Text>
                <Input
                  required
                  onChange={(e) => setAssignmentValue(itemId, type, e, setOrderMultiple)}
                  placeholder="Order Multiple"
                  value={orderMultiple}
                  type="number"
                  step="1"
                  disabled={submitted}
                />
              </div>
            }
            { settings?.settings?.pack_quantities && 
              <div className="flex-container flex-end">
                <Text as='span'>Pack Quantity &nbsp;&nbsp;</Text>
                <Input
                  required
                  onChange={(e) => setAssignmentValue(itemId, type, e, setPackQuantity)}
                  placeholder="Pack Quantity"
                  value={packQuantity}
                  type="number"
                  step="1"
                  disabled={submitted}
                />
              </div>
            }

          </div>
        }

        { assignments.itemSearchingAssignments.find(item => item === `${productId}/${itemId}`) &&
          <LoadingSpinner
            size="xxSmall"
            statusText="Loading Assignments"
          />
        }

        { lineAssigned &&
          <>
            <div className="flex-3">
              <div className="left-15">
                <H4>Assignment Details</H4>
                <ul>
                  <li>Supplier SKU: <Badge label={JSON.parse(lineAssigned.value).supplier_sku || "Not set"} variant={JSON.parse(lineAssigned.value).supplier_sku ? "success" : "warning"} /></li>
                  <li>Supplier Price: <Badge label={JSON.parse(lineAssigned.value).supplier_price ? format(JSON.parse(lineAssigned.value).supplier_price) : "Not set"} variant={JSON.parse(lineAssigned.value).supplier_price ? "success" : "warning"} /></li>
                  <li>Minimum Order Quantity: <Badge label={JSON.parse(lineAssigned.value).minimum_order || "Not set"} variant={JSON.parse(lineAssigned.value).minimum_order ? "success" : "warning"} /></li>
                  { settings?.settings?.order_multiples && 
                    <li>Order Multiple: <Badge label={JSON.parse(lineAssigned.value).order_multiple || "Not set"} variant={JSON.parse(lineAssigned.value).order_multiple ? "success" : "warning"} /></li>
                  }
                  { settings?.settings?.pack_quantities && 
                    <li>Pack Quantity: <Badge label={JSON.parse(lineAssigned.value).pack_quantity || "Not set"} variant={JSON.parse(lineAssigned.value).pack_quantity ? "success" : "warning"} /></li>
                  }
                </ul>
              </div>
            </div>
            <div className="flex-2">
              <Button
                onClick={() => showEditModal()}
                variant="secondary"
                disabled={submitted || assignments.updatingAssignments.find(assignmentId => assignmentId === `${productId}/${itemId}`)}
                isLoading={assignments.updatingAssignments.find(assignmentId => assignmentId === `${productId}/${itemId}`)}
                iconLeft={<EditIcon />}
              >
                Edit Assignment
              </Button>
              <br/>
              <br/>
              <Button
                onClick={() => showDeleteModal()}
                variant="secondary"
                actionType="destructive"
                disabled={submitted || assignments.updatingAssignments.find(assignmentId => assignmentId === `${productId}/${itemId}`)}
                isLoading={assignments.updatingAssignments.find(assignmentId => assignmentId === `${productId}/${itemId}`)}
                iconLeft={<DeleteIcon />}
              >
                Remove Assignment
              </Button>
            </div>
          </>
        }
      </div>

      <EditAssignmentModal
        payload={payload}
        supplierId={supplierId}
        showEditAssignmentModal={showEditAssignmentModal}
        setShowEditAssignmentModal={setShowEditAssignmentModal}
        assignment={activeAssignment}
        assignmentName={name}
      />

      <DeleteAssignmentModal
        payload={payload}
        supplierId={supplierId}
        showDeleteAssignmentModal={showDeleteAssignmentModal}
        setShowDeleteAssignmentModal={setShowDeleteAssignmentModal}
        assignment={activeAssignment}
        assignmentName={name}
      />
    </>
  )
}

const mapStateToProps = state => ({
  selectedProductList: state.products.selectedProductList,
  products: state.products,
  assignments: state.assignments,
  bigcommerceSettings: state.stores.settings,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedProductList: (items) => dispatch(updateSelectedItems(items)),
  getAssignments: (payload, supplierId, productId, variantId) => dispatch(assignmentsByItem(payload, supplierId, productId, variantId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemLine);
